import React, { FC } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import { Thumbnails } from 'yet-another-react-lightbox/plugins';
import 'yet-another-react-lightbox/dist/styles.css';
import 'yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css';
import { LightBoxProps } from './LightBox.types';

export const LightBox: FC<LightBoxProps> = props => {
  const { isOpen, onClose, photos, selectedPhotoIndex, onChange } = props;

  return (
    <Lightbox
      on={{
        view: ({ index }) => {
          onChange?.(index);
        },
      }}
      open={isOpen}
      close={onClose}
      slides={photos}
      carousel={{
        finite: true,
      }}
      index={selectedPhotoIndex}
      plugins={[Thumbnails]}
      thumbnails={{
        position: 'bottom',
      }}
      styles={{
        container: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
        icon: {
          color: 'white',
        },
        button: {
          filter: 'none',
        },
      }}
    />
  );
};
